<template>
  <div class="rotating-earth-background">
    <div id="earth-map" class="earth-map"></div>
    <div class="earth-overlay"></div>
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'

export default {
  name: 'RotatingEarthBackground',
  data() {
    return {
      map: null,
      rotationSpeed: 0.5, // Degrees per second
      animationFrame: null
    }
  },
  mounted() {
    this.initMap()
  },
  beforeUnmount() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame)
    }
    if (this.map) {
      this.map.remove()
    }
  },
  methods: {
    initMap() {
      // Set Mapbox access token from environment variable
      mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN

      // Initialize the map with globe projection
      this.map = new mapboxgl.Map({
        container: 'earth-map',
        style: 'mapbox://styles/mapbox/satellite-v9',
        center: [0, 20],
        zoom: 1.5,
        projection: 'globe',
        interactive: false, // Disable all interactions
        attributionControl: false // Remove Mapbox attribution
      })

      // Disable all map interactions
      this.map.dragPan.disable()
      this.map.scrollZoom.disable()
      this.map.boxZoom.disable()
      this.map.dragRotate.disable()
      this.map.keyboard.disable()
      this.map.doubleClickZoom.disable()
      this.map.touchZoomRotate.disable()

      // Set up the globe atmosphere when style loads
      this.map.on('style.load', () => {
        this.map.setFog({
          color: '#1a1a2e',
          'horizon-blend': 0.05,
          'high-color': '#0f172a',
          'space-color': '#0a0a0f',
          'star-intensity': 0.8
        })

        // Start the rotation animation
        this.startRotation()
      })
    },

    startRotation() {
      let lastTime = Date.now()
      let currentLng = 0

      const rotate = () => {
        const currentTime = Date.now()
        const delta = (currentTime - lastTime) / 1000 // Time delta in seconds
        lastTime = currentTime

        // Update longitude based on rotation speed
        currentLng += this.rotationSpeed * delta

        // Keep longitude within bounds
        if (currentLng > 180) {
          currentLng -= 360
        }

        // Update map center to create rotation effect
        this.map.setCenter([currentLng, 20])

        // Continue animation
        this.animationFrame = requestAnimationFrame(rotate)
      }

      rotate()
    }
  }
}
</script>

<style scoped>
.rotating-earth-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  overflow: hidden;
}

.earth-map {
  width: 100%;
  height: 100%;
}

.earth-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    ellipse at center,
    rgba(26, 26, 46, 0.2) 0%,
    rgba(26, 26, 46, 0.4) 40%,
    rgba(26, 26, 46, 0.7) 80%,
    rgba(26, 26, 46, 0.85) 100%
  );
  pointer-events: none;
}
</style>
